import { create } from 'zustand';
import { message } from 'antd';
import axiosInstance from '../utils/axiosInstance';
import { getCachedData, setCachedData, clearCacheByKey } from '../utils/cacheUtil';

const useEmployeeStore = create((set) => ({
  employees: [],
  loading: false,
  error: null,

  fetchEmployees: async () => {
    const cached = getCachedData('employees');
    if (cached) {
      set({ employees: cached, loading: false, error: null });
      return;
    }

    set({ loading: true });
    try {
      const response = await axiosInstance.get('/employees/');
      setCachedData('employees', response.data);
      set({ 
        employees: response.data,
        loading: false,
        error: null 
      });
    } catch (error) {
      set({ error: error.message, loading: false });
      message.error('Failed to fetch employees');
    }
  },

  createEmployee: async (employeeData) => {
    set({ loading: true });
    try {
      const response = await axiosInstance.post('/employees/', employeeData);
      clearCacheByKey('employees');
      set(state => ({
        employees: [...state.employees, response.data],
        loading: false,
      }));
      message.success('Employee created successfully');
      return { success: true, data: response.data };
    } catch (error) {
      set({ loading: false });
      message.error('Failed to create employee');
      return { success: false, error };
    }
  },

  updateEmployee: async (id, employeeData) => {
    set({ loading: true });
    try {
      const response = await axiosInstance.put(`/employees/${id}/`, employeeData);
      clearCacheByKey('employees');
      set(state => ({
        employees: state.employees.map(emp => 
          emp.id === id ? response.data : emp
        ),
        loading: false,
      }));
      message.success('Employee updated successfully');
      return { success: true, data: response.data };
    } catch (error) {
      set({ loading: false });
      message.error('Failed to update employee');
      return { success: false, error };
    }
  },

  deleteEmployee: async (id) => {
    try {
      await axiosInstance.delete(`/employees/${id}/`);
      clearCacheByKey('employees');
      set(state => ({
        employees: state.employees.filter(emp => emp.id !== id),
      }));
      message.success('Employee deleted successfully');
      return { success: true };
    } catch (error) {
      message.error('Failed to delete employee');
      return { success: false, error };
    }
  },
}));

export default useEmployeeStore;
